import { State } from '@hookstate/core'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import {
  CollapsibleContainer,
  CollapsibleHeader,
  CollapsibleBody
} from './../../../metrics/infrastructure/slot-status/operation-models/partials.component'

type CollapsibleSubModuleProps = {
  title: string
  children?: React.ReactNode
  displayValues: State<{}, {}>
  collapsibleIndex: number
  initialState: { [key: number]: boolean }
}

const CollapsibleSubModule = ({
  title,
  children,
  displayValues,
  collapsibleIndex,
  initialState
}: CollapsibleSubModuleProps) => {
  return (
    <CollapsibleContainer aria-label='operating-model' large={true}>
      <CollapsibleHeader primaryColor={'#000000'} large={true} show={displayValues.get()[collapsibleIndex]}>
        <p>{title}</p>
        <div>
          {displayValues.get()[collapsibleIndex] ? (
            <UpOutlined onClick={() => displayValues.set(initialState)} />
          ) : (
            <DownOutlined
              onClick={() => {
                displayValues.set({ ...initialState, [collapsibleIndex]: true })
              }}
            />
          )}
        </div>
      </CollapsibleHeader>
      <CollapsibleBody show={displayValues.get()[collapsibleIndex]}>
        {displayValues.get()[collapsibleIndex] && children}
      </CollapsibleBody>
    </CollapsibleContainer>
  )
}

export { CollapsibleSubModule }
